export default __webpack_public_path__ + "static/media/step4-b.bc6f0aea.png";